import { ResponseService } from './../services/response.service';
import { ServersService } from './../services/servers.service';
import { NotificationsService } from 'angular2-notifications';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from './../services/api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-new-message',
  templateUrl: './new-message.component.html',
})
export class NewMessageComponent implements OnInit {

  messageForm: FormGroup;
  selectedFiles: Array<any>;

  services: any = {};

  constructor(
    private http: Http,
    private apiService: ApiService,
    private localStorageService: LocalStorageService,
    private serversService: ServersService,
    private notificationsService: NotificationsService,
    private responseService: ResponseService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.selectedFiles = [];
    this.route.queryParams.subscribe(params => {
      this.messageForm = new FormGroup({
        subject: new FormControl(+params['severity'] || 3, [Validators.required]),
        service: new FormControl(params['service'] || '', [Validators.required]),
        message: new FormControl('', [Validators.required]),
        company_id: new FormControl(this.localStorageService.get('company'), [Validators.required]),
        uploaded_files: new FormControl(''),
      });
    })
  }

  ngOnInit() {
    this.apiService.get('/company/' + this.localStorageService.get('company') + '/services')
    .subscribe(
      (response) => {
        const services = this.responseService.success(false, response, 'services');
        this.services = services;
      },
      (error) => {
        this.responseService.error(error);
      }
    );

    // this.serversService.getAllCompanyServers().subscribe(
    //   (servers) => {
    //     this.services = servers;
    //   },
    //   (error) => {
    //     this.notificationsService.error('Ups', 'Błąd podczas pobierania listy usług');
    //   }
    // );
  }

  sendMessage() {
    this.messageForm.get('uploaded_files').setValue(this.selectedFiles);
    this.apiService.post('/message', this.messageForm.value).subscribe(
      (response) => {
        this.responseService.success(true, response);
        this.router.navigateByUrl('/messages/list');
      },
      (error) => {

        var messages = {
          'message': 'Treść wiadomości nie może być pusta.',
          'server': 'Proszę wybrać serwer, którego dotyczy awaria.',
          'subject': 'Brak wybranego tematu wiadomości. Prosimy odświeżyć stronę. Jeżeli problem się powtórzy prosimy o kontakt z BOK Data Space.',
          'company_id': 'Niepoprawny stan aplikacji. Prosimy odświeżyć stronę.',
          'uploaded_files': 'Wielkość pliku jest zbyt duża lub niezgodny typ'
        }
        
        for (var key in error) {
          var message;
          if ((message = messages[key]) !== undefined) {
            this.notificationsService.error('Ups', message);
          }
          if(/^uploaded_files/.test(key)){
            message = messages['uploaded_files'];
            this.notificationsService.error('Ups', message);
          }
        };
          

        if (message === undefined) {
          this.notificationsService.error('Ups', 'Wystąpił nieznany błąd podczas wysyłania wiadomości. Prosimy odświeżyć stronę. Jeżeli problem się powtórzy prosimy o kontakt z BOK Data Space.');
        }
      }
    );
  }

  onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
        let file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
  
          this.selectedFiles.push({
            filename: file.name,
            filetype: file.type,
            file_extension: file.name.split('.')[file.name.split('.').length-1],
            value: reader.result.split(',')[1]
          });
        };
      
    }
  }

  removeFile(file) {
    this.selectedFiles.splice(file, 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/messages/new-message.component.ts